import global from "./global.config"

export default {
  global:global
}
